/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationAliases {
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  CARD_NEGOTIATION = 'card-negotiation',
  CONTEXTUAL_BAR_NEGOTIATION = 'contextual-bar-negotiation',
  DECK_NEGOTIATION = 'deck-negotiation',
  FETCH_LOCATOR = 'fetch-locator',
  FETCH_NEGOTIATION = 'fetch-negotiation',
  FIELD_LOCATOR = 'field-locator',
  FIELD_NEGOTIATION = 'field-negotiation',
  FIELD_PROPONENT = 'field-proponent',
  FILTER = 'filter',
  FILTERED_LIST_0 = 'filtered-list-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_NEGOTIATION = 'panel-negotiation',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
  TEXT_NEGOTIATION = 'text-negotiation',
  TEXT_PROPONENT = 'text-proponent',
}
export { NegotiationAliases };
